import ContactsHero from "../components/Contacts/ContactsHero";

const Contacts = () => {
    return(
        <div>
            <ContactsHero />
        </div>
    );
}

export default Contacts;